import React from 'react';
import { ChevronLeft, Folder } from 'lucide-react';
import { Category } from '../../types';
import { buildCategoryPath } from '../../lib/utils';

interface CategoryPathProps {
  category: Category;
  allCategories: Category[];
  className?: string;
  showIcons?: boolean;
  maxDepth?: number;
}

const CategoryPath: React.FC<CategoryPathProps> = ({
  category,
  allCategories,
  className = '',
  showIcons = true,
  maxDepth = 5
}) => {
  const path = buildCategoryPath(category, allCategories);
  
  // Limit depth if specified
  const displayPath = maxDepth ? path.slice(-maxDepth) : path;

  if (displayPath.length === 0) {
    return <span className="text-gray-400">بدون دسته‌بندی</span>;
  }

  return (
    <div className={`flex items-center flex-wrap gap-1 ${className}`}>
      {displayPath.map((cat, index) => (
        <React.Fragment key={cat.id}>
          {index > 0 && (
            <ChevronLeft className="h-3 w-3 text-gray-400 mx-1 flex-shrink-0" />
          )}
          <div className="flex items-center gap-1 group">
            {showIcons && (
              <Folder className="h-3 w-3 text-gray-500 group-hover:text-primary-600 transition-colors" />
            )}
            <span 
              className={`text-sm transition-colors ${
                index === displayPath.length - 1
                  ? 'text-primary-600 font-medium'
                  : 'text-gray-600 hover:text-gray-900'
              }`}
              title={cat.title}
            >
              {cat.title}
            </span>
          </div>
        </React.Fragment>
      ))}
    </div>
  );
};

export default CategoryPath; 